import { createSelector } from 'reselect';
import get from 'lodash.get';
import { getPageData } from 'src/universal/redux/page';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';

export const getCorpSegmentsImpressions = createSelector([getPageData], pageData => {
  const arrOfEvents = get(pageData, 'corpSegmentsNav.dtmEvents') || [];
  return parseArrayToObject(arrOfEvents, 'tag').impression;
});

export const getSegmentNavData = createSelector(
  [getPageData],
  ({ corpSegmentsNav = {} }) => {
    return { ...corpSegmentsNav };
  }
);

export const getCorpPdpTabbedData = createSelector(
  [getPageData],
  ({ corpPdpTabbed = {} }) => {
    return { ...corpPdpTabbed };
  }
);
